var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnlineMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "online-meeting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.041,
    height: 23.648,
    viewBox: "0 0 36.041 23.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M285.553,281.138a5.516,5.516,0,0,0-1.965.019,2.946,2.946,0,0,0-2.087,2.134h6.15A2.906,2.906,0,0,0,285.553,281.138Z",
    transform: "translate(-260.259 -265.36)",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M299.8,242.5a1.5,1.5,0,1,0,.009-3,1.5,1.5,0,1,0-.009,3Z",
    transform: "translate(-275.478 -227.709)",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M232.475,316.689c-.019-.169-.047-.329-.075-.489h0A2.929,2.929,0,0,1,232.475,316.689Z",
    transform: "translate(-215.776 -297.197)",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M143.775,316.3a2.788,2.788,0,0,0-.075.489c.019-.169.047-.338.075-.489Z",
    transform: "translate(-135.416 -297.287)",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M66.9,338.5v1.486h7a5.138,5.138,0,0,1-.6-1.486Z",
    transform: "translate(-65.837 -317.4)",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M242.594,179.217h13.982V167.464H255.6v2.322a2.607,2.607,0,0,1-.009.386.509.509,0,0,1-.564.461.482.482,0,0,1-.48-.508c-.009-.649,0-1.288,0-1.993a1.806,1.806,0,0,0-.254.15c-.527.395-1.053.78-1.58,1.185a.9.9,0,0,1-1.514-.752v-1.279h-.78a.881.881,0,0,1-.95-.94c-.009-.856,0-1.711,0-2.6h-5.454v13.267c.3,0,.6.009.9-.009a.254.254,0,0,0,.188-.15,4.365,4.365,0,0,1,2.2-2.783c-.874-1.6-.752-2.849.367-3.733a2.58,2.58,0,0,1,3.272.075c1.044.912,1.147,2.181.31,3.573a11.192,11.192,0,0,1,1.363,1.3,12.159,12.159,0,0,1,.94,1.711h.978v-4.466c0-.395.188-.611.517-.621a.513.513,0,0,1,.536.536c.009,1.6.019,3.188-.009,4.786a.85.85,0,0,1-.94.837c-1.166.009-2.323,0-3.489,0H242.5a4.938,4.938,0,0,1,.085.921A.207.207,0,0,1,242.594,179.217Zm2.8-13.39a.542.542,0,0,1-.5-.536.528.528,0,0,1,.555-.508.542.542,0,0,1,.5.536A.523.523,0,0,1,245.4,165.828Zm1.514,0a.527.527,0,1,1,.527-.545A.536.536,0,0,1,246.91,165.828Z",
    transform: "translate(-224.926 -159.217)",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M337.418,131.684V125.6H328.1v6.084h.686A.9.9,0,0,1,329.8,132.7c.009.339,0,.668,0,1.063.15-.1.235-.15.32-.216.686-.517,1.373-1.016,2.05-1.542a1.511,1.511,0,0,1,.968-.329C334.56,131.693,335.97,131.684,337.418,131.684Zm-6.676-4.758h4.006a1.138,1.138,0,0,1,.179.009.521.521,0,0,1,.5.536.5.5,0,0,1-.517.508c-.724.009-1.448,0-2.181,0h-2c-.414,0-.649-.207-.639-.536S330.338,126.926,330.742,126.926Zm-.066,3.413a.539.539,0,0,1-.592-.555c.019-.3.235-.489.6-.5.7-.009,1.382,0,2.078,0h2.04c.4,0,.611.179.621.508s-.216.536-.6.545Q332.75,130.353,330.676,130.339Z",
    transform: "translate(-302.477 -124.519)",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M63.658,151.544h-7v-1.486h6.394a4.759,4.759,0,0,1-.132-1.1H59.954V131.826c-.009-.188.075-.282.273-.273H65.05c.461,0,.724-.3.611-.677-.094-.31-.348-.376-.639-.376H60.377c-1.025,0-1.476.451-1.476,1.486v17c-.743,0-1.476.019-2.191-.009a1.038,1.038,0,0,0-1.11.668v2.323a1.2,1.2,0,0,0,1.213.639c2.567,0,5.134-.009,7.7-.009A4.829,4.829,0,0,1,63.658,151.544Z",
    transform: "translate(-55.6 -128.958)",
    fill: "#fafaf2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M145.267,304.8a4,4,0,0,0-.367.931,4.356,4.356,0,0,1,.367-.931Z",
    transform: "translate(-136.503 -286.869)",
    fill: "#fafaf2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M142.991,135.106a.89.89,0,0,0-.978-.987c-.649-.009-1.288,0-1.937,0-.122,0-.244-.019-.357-.019V122.328h2.2c.743,0,1.072-.329,1.072-1.072v-6.018c0-.827-.31-1.138-1.147-1.138H132.62c-.8,0-1.11.31-1.119,1.1v.442H119.286a2.152,2.152,0,0,0-.348.009.486.486,0,0,0-.47.48.5.5,0,0,0,.395.545,1.581,1.581,0,0,0,.423.019h12.2v1h-18c-.884,0-1.185.3-1.185,1.175v13.061c0,.893.282,1.175,1.175,1.175h.884a4.557,4.557,0,0,1,.32-1.072h-1.241V118.867H125v13.164h-.771a5.662,5.662,0,0,1,.32,1.072h12.139a.845.845,0,0,0,.94-.837c.019-1.6.019-3.188.009-4.786a.513.513,0,0,0-.536-.536c-.32,0-.517.226-.517.621v4.466h-.978a12.259,12.259,0,0,0-.94-1.711,11.924,11.924,0,0,0-1.363-1.3c.837-1.392.733-2.661-.31-3.573a2.568,2.568,0,0,0-3.272-.075c-1.119.884-1.241,2.134-.367,3.733a4.372,4.372,0,0,0-2.2,2.783.277.277,0,0,1-.188.15c-.3.019-.6.009-.9.009V118.783h5.454c0,.884-.009,1.74,0,2.6a.877.877,0,0,0,.95.94c.254.009.508,0,.78,0V123.6a.906.906,0,0,0,.5.9.92.92,0,0,0,1.016-.15c.517-.395,1.053-.79,1.58-1.185.066-.047.141-.085.254-.15,0,.705-.009,1.345,0,1.993a.477.477,0,0,0,.48.508.514.514,0,0,0,.564-.461,2.606,2.606,0,0,0,.009-.385v-2.323h.978V134.1H124.646a5.334,5.334,0,0,1-.132,1.1h17.414v1.486h-8.359c-.414,0-.649.188-.649.527s.235.527.649.527h8.444a.9.9,0,0,0,1-1.006C143,136.187,143,135.651,142.991,135.106ZM131.3,125.891a1.5,1.5,0,1,1-1.514,1.514A1.513,1.513,0,0,1,131.3,125.891ZM130.3,129.9a5.114,5.114,0,0,1,1.965-.019,2.9,2.9,0,0,1,2.1,2.163h-6.15A2.943,2.943,0,0,1,130.3,129.9Zm11.613-8.632c-1.448,0-2.858.009-4.278-.009a1.443,1.443,0,0,0-.968.329c-.677.527-1.363,1.034-2.05,1.542-.085.066-.169.113-.32.216v-1.063a.9.9,0,0,0-1.016-1.016h-.686v-6.084h9.318",
    transform: "translate(-106.969 -114.1)",
    fill: "#fafaf2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M144.628,314.8l-.028.141h0Z",
    transform: "translate(-136.231 -295.928)",
    fill: "#fafaf2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M228.567,305.831a4,4,0,0,0-.367-.931h0A4.461,4.461,0,0,1,228.567,305.831Z",
    transform: "translate(-211.971 -286.959)",
    fill: "#fafaf2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M232.128,314.941l-.028-.141.028.141Z",
    transform: "translate(-215.504 -295.928)",
    fill: "#fafaf2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M226.7,355.313h7.56a2.6,2.6,0,0,0,.386-.009.5.5,0,0,0,.461-.564.488.488,0,0,0-.508-.48c-.113-.009-.235,0-.348,0h-6.714A5.357,5.357,0,0,1,226.7,355.313Z",
    transform: "translate(-210.612 -331.674)",
    fill: "#fafaf2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M268.652,173.19a.523.523,0,1,0,.5.536A.542.542,0,0,0,268.652,173.19Z",
    transform: "translate(-248.116 -167.633)",
    fill: "#fafaf2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M284.324,173.2a.528.528,0,0,0-.527.508.527.527,0,1,0,.527-.508Z",
    transform: "translate(-262.34 -167.643)",
    fill: "#fafaf2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M349.749,140.753c.668.009,1.335,0,2,0h0c.724,0,1.448.009,2.181,0a.5.5,0,0,0,.517-.508.515.515,0,0,0-.5-.536,1.079,1.079,0,0,0-.179-.009h-4.006c-.414,0-.658.2-.668.517S349.345,140.753,349.749,140.753Z",
    transform: "translate(-321.503 -137.293)",
    fill: "#fafaf2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M354.531,165.408c-.009-.329-.216-.508-.621-.508h-4.118c-.367,0-.592.2-.6.5a.539.539,0,0,0,.592.555q2.073.014,4.147,0A.54.54,0,0,0,354.531,165.408Z",
    transform: "translate(-321.583 -160.123)",
    fill: "#fafaf2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M159.8,288.944c.1-.085.216-.169.329-.244C160.016,288.775,159.913,288.86,159.8,288.944Z",
    transform: "translate(-150.002 -272.283)",
    fill: "#fafaf2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M209.9,286.4a2.681,2.681,0,0,1,.348.216C210.135,286.541,210.022,286.466,209.9,286.4Z",
    transform: "translate(-195.391 -270.199)",
    fill: "#fafaf2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M149.026,300.8a3.065,3.065,0,0,0-.226.376h0A3.981,3.981,0,0,1,149.026,300.8Z",
    transform: "translate(-140.037 -283.245)",
    fill: "#fafaf2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M197.5,281.9c.141.028.273.066.4.1C197.773,281.966,197.641,281.928,197.5,281.9Z",
    transform: "translate(-184.157 -266.122)",
    fill: "#fafaf2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M226.026,301.176a3.065,3.065,0,0,0-.226-.376,3.981,3.981,0,0,1,.226.376Z",
    transform: "translate(-209.796 -283.245)",
    fill: "#fafaf2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M220.3,294.2a4.192,4.192,0,0,1,.517.63A4.192,4.192,0,0,0,220.3,294.2Z",
    transform: "translate(-204.813 -277.265)",
    fill: "#fafaf2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M213.6,288.7c.113.075.226.16.329.244C213.826,288.86,213.713,288.775,213.6,288.7Z",
    transform: "translate(-198.743 -272.283)",
    fill: "#fafaf2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M199.3,245.2a.387.387,0,0,1,.066.1A.99.99,0,0,0,199.3,245.2Z",
    transform: "translate(-185.788 -232.873)",
    fill: "#fafaf2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M171.9,245.3c.019-.038.047-.066.066-.1C171.947,245.228,171.928,245.266,171.9,245.3Z",
    transform: "translate(-160.964 -232.873)",
    fill: "#fafaf2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M163.3,286.616c.113-.075.226-.15.348-.216C163.526,286.466,163.413,286.541,163.3,286.616Z",
    transform: "translate(-153.173 -270.199)",
    fill: "#fafaf2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M151.2,294.73a4.724,4.724,0,0,1,.517-.63A4.6,4.6,0,0,0,151.2,294.73Z",
    transform: "translate(-142.211 -277.175)",
    fill: "#fafaf2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M160.727,232.389a1.556,1.556,0,0,1-.686-1.288,1.514,1.514,0,0,1,.235-.818c.019-.038.047-.066.066-.1a1.432,1.432,0,0,1,.385-.367,1.525,1.525,0,0,1,.874-.263,1.547,1.547,0,0,1,.874.263,1.785,1.785,0,0,1,.385.367.388.388,0,0,1,.066.1,1.514,1.514,0,0,1,.235.818,1.544,1.544,0,0,1-.686,1.288,1.387,1.387,0,0,1-.5.216,5.036,5.036,0,0,1,1.41.235,2.476,2.476,0,0,0,.715-1.74,2.5,2.5,0,1,0-4.165,1.862,5.221,5.221,0,0,1,1.382-.339A1.4,1.4,0,0,1,160.727,232.389Z",
    transform: "translate(-149.368 -217.834)",
    fill: "#fafaf2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M172.986,241.3a1.785,1.785,0,0,0-.386.367A1.585,1.585,0,0,1,172.986,241.3Z",
    transform: "translate(-161.599 -229.34)",
    fill: "#fafaf2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M195.586,241.667a1.432,1.432,0,0,0-.385-.367A1.432,1.432,0,0,1,195.586,241.667Z",
    transform: "translate(-182.074 -229.34)",
    fill: "#fafaf2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M154.669,355.353h4.053a4.257,4.257,0,0,0,1.26-1.053H153.4A4.418,4.418,0,0,0,154.669,355.353Z",
    transform: "translate(-144.204 -331.714)",
    fill: "#fafaf2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M143.569,327.9H151.7a3.842,3.842,0,0,0,.16-1.1H143.4A5.364,5.364,0,0,0,143.569,327.9Z",
    transform: "translate(-135.144 -306.8)",
    fill: "#fafaf2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M152.856,305.972l-.028-.141a4,4,0,0,0-.367-.931h-7.466a4,4,0,0,0-.367.931l-.028.141Z",
    transform: "translate(-136.231 -286.959)",
    fill: "#fafaf2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M228.567,305.831l.028.141h.959a4.56,4.56,0,0,0-.32-1.072H228.2A4.461,4.461,0,0,1,228.567,305.831Z",
    transform: "translate(-211.971 -286.959)",
    fill: "#fafaf2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M142.447,354.3H141.3a5.076,5.076,0,0,0,.846,1.053h1.561A4.257,4.257,0,0,1,142.447,354.3Z",
    transform: "translate(-133.242 -331.714)",
    fill: "#fafaf2"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M134.6,327.9a3.842,3.842,0,0,1-.16-1.1h-.94a5.333,5.333,0,0,0,.132,1.1Z",
    transform: "translate(-126.175 -306.8)",
    fill: "#fafaf2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M210.1,355.353h1.561a5.032,5.032,0,0,0,.837-1.053h-1.147A4.221,4.221,0,0,1,210.1,355.353Z",
    transform: "translate(-195.573 -331.714)",
    fill: "#fafaf2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M135.387,305.831a4,4,0,0,1,.367-.931H134.72a5.665,5.665,0,0,0-.32,1.072h.959Z",
    transform: "translate(-126.991 -286.959)",
    fill: "#fafaf2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M231.96,326.8a4.636,4.636,0,0,1-.16,1.1h.968a4.759,4.759,0,0,0,.132-1.1Z",
    transform: "translate(-215.232 -306.8)",
    fill: "#fafaf2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M190.994,273.5a2.2,2.2,0,0,1-1.194.705,3.874,3.874,0,0,1,.564.075c.122.028.244.066.367.1a3.513,3.513,0,0,1,.686.32,2.385,2.385,0,0,1,.32.216,3.652,3.652,0,0,1,.292.244,3.737,3.737,0,0,1,.273.273,4.574,4.574,0,0,1,.47.63c.075.122.141.244.207.376h.94A4.92,4.92,0,0,0,190.994,273.5Z",
    transform: "translate(-177.181 -258.512)",
    fill: "#fafaf2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M142.747,277.154a4.392,4.392,0,0,1,.47-.63,3.735,3.735,0,0,1,.273-.273c.094-.085.2-.169.291-.244a3.6,3.6,0,0,1,1.006-.536c.122-.038.244-.075.367-.1.094-.019.2-.038.3-.056a2.164,2.164,0,0,1-1.241-.611,4.989,4.989,0,0,0-2.614,2.821h.94C142.606,277.4,142.672,277.267,142.747,277.154Z",
    transform: "translate(-133.514 -259.599)",
    fill: "#fafaf2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M170.125,272.04a2.474,2.474,0,0,0,1.316-.705,5.035,5.035,0,0,0-1.41-.235,1.645,1.645,0,0,1-.376.047,1.275,1.275,0,0,1-.273-.028,4.879,4.879,0,0,0-1.382.339,2.485,2.485,0,0,0,1.363.611,4.786,4.786,0,0,1,.527-.038A1.889,1.889,0,0,1,170.125,272.04Z",
    transform: "translate(-157.431 -256.337)",
    fill: "#fafaf2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineMeeting);
export default __webpack_public_path__ + "static/media/online-meeting.f9f50959a0cb3ea8873fdcf6de690cc1.svg";
export { ForwardRef as ReactComponent };